<app-quota-summary-bar></app-quota-summary-bar>
<div class="page-container">
  <div class="page-header">
    <h1>{{ 'currentSuppliers.title' | translate }}</h1>
  </div>

  <!-- Tab bar -->
  <div class="tab-buttons">
    @for (tab of tabs; track tab.value) {
      <button
        class="tab-btn"
        [class.active]="activeTab() === tab.value"
        (click)="setActiveTab(tab.value)">
        <span class="tab-label">{{ tab.labelKey | translate }}</span>
        <span class="tab-count">{{ getTabCount(tab.value) }}</span>
      </button>
    }
  </div>

  @if (loading()) {
    <div class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
      <p>{{ 'currentSuppliers.loading' | translate }}</p>
    </div>
  } @else if (error()) {
    <div class="error-container">
      <mat-icon>error_outline</mat-icon>
      <p>{{ error() }}</p>
      <button mat-raised-button color="primary" (click)="loadData()">
        {{ 'currentSuppliers.retry' | translate }}
      </button>
    </div>
  } @else {
    <div class="table-container">
      <table mat-table [dataSource]="assignments()" class="assignments-table">
        <!-- Number Column -->
        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let assignment; let i = index">{{ i + 1 }}</td>
        </ng-container>

        <!-- Year Column -->
        <ng-container matColumnDef="year">
          <th mat-header-cell *matHeaderCellDef>{{ 'currentSuppliers.year' | translate }}</th>
          <td mat-cell *matCellDef="let assignment">{{ assignment.application.quotaYear }}</td>
        </ng-container>

        <!-- Stage Column -->
        <ng-container matColumnDef="stage">
          <th mat-header-cell *matHeaderCellDef>{{ 'currentSuppliers.stage' | translate }}</th>
          <td mat-cell *matCellDef="let assignment">{{ getStageLabel(assignment.stage) }}</td>
        </ng-container>

        <!-- Company Name Column -->
        <ng-container matColumnDef="companyName">
          <th mat-header-cell *matHeaderCellDef>{{ 'currentSuppliers.companyName' | translate }}</th>
          <td mat-cell *matCellDef="let assignment">{{ assignment.application.companyName }}</td>
        </ng-container>

        <!-- Requested Volume Column -->
        <ng-container matColumnDef="requestedVolume">
          <th mat-header-cell *matHeaderCellDef class="number-cell">{{ 'currentSuppliers.requestedVolume' | translate }}</th>
          <td mat-cell *matCellDef="let assignment" class="number-cell">
            {{ assignment.application.requestedVolume | kgToTons }}
          </td>
        </ng-container>

        <!-- Allocated Volume Column -->
        <ng-container matColumnDef="allocatedVolume">
          <th mat-header-cell *matHeaderCellDef class="number-cell">{{ 'currentSuppliers.allocatedVolume' | translate }}</th>
          <td mat-cell *matCellDef="let assignment" class="number-cell">
            {{ assignment.allocatedVolume | kgToTons }}
          </td>
        </ng-container>

        <!-- Remainder Volume Column -->
        <ng-container matColumnDef="remainderVolume">
          <th mat-header-cell *matHeaderCellDef class="number-cell">{{ 'currentSuppliers.remainderVolume' | translate }}</th>
          <td mat-cell *matCellDef="let assignment" class="number-cell">
            {{ assignment.remainderVolume | kgToTons }}
          </td>
        </ng-container>

        <!-- Meat Type Column -->
        <ng-container matColumnDef="meatType">
          <th mat-header-cell *matHeaderCellDef>{{ 'currentSuppliers.meatType' | translate }}</th>
          <td mat-cell *matCellDef="let assignment">{{ getMeatTypeName(assignment.application.meatType) }}</td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>{{ 'currentSuppliers.status' | translate }}</th>
          <td mat-cell *matCellDef="let assignment">
            <span class="status-badge" [class]="'status-' + assignment.status.toLowerCase()">
              {{ getStatusLabel(assignment.status) }}
            </span>
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ 'currentSuppliers.action' | translate }}</th>
          <td mat-cell *matCellDef="let assignment">
            <button mat-icon-button [matMenuTriggerFor]="menu" class="menu-trigger">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="addVolume(assignment)">
                <!-- <mat-icon>add</mat-icon> -->
                <span>{{ 'currentSuppliers.addVolume' | translate }}</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item (click)="revokeQuota(assignment)">
                <!-- <mat-icon>block</mat-icon> -->
                <span>{{ 'currentSuppliers.revokeQuota' | translate }}</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns();"></tr>

        <!-- No data row -->
        <tr class="mat-row no-data-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns().length">
            {{ 'currentSuppliers.noData' | translate }}
          </td>
        </tr>
      </table>
    </div>
  }
</div>
